let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("49P4R")).then(() => parcelRequire('3JSSn'));